import { UserSquareIcon } from '@phosphor-icons/react';
import { useNavigate } from '@tanstack/react-router';
import { GuestLogContent } from '@/content/GuestLogContent';
import { useGuestCountToday } from '@/lib/hooks/useGuests';
import { ActionCard } from '@/components/ui/ActionCard';

export function GuestLogCard() {
  const navigate = useNavigate();
  const { data: guestCount = 0, isLoading } = useGuestCountToday();

  const handleClick = () => {
    navigate({ to: '/admin/guest-log' });
  };

  const subtext = isLoading
    ? `... ${GuestLogContent.card.countLabel}`
    : `${guestCount} ${GuestLogContent.card.countLabel}`;

  return (
    <ActionCard
      title={GuestLogContent.card.viewLogCta}
      subtext={subtext}
      icon={UserSquareIcon}
      hasBadge={true}
      badgeColor="purple"
      onClickAction={handleClick}
    />
  );
}
